import get from 'lodash/get';
import {Page} from 'src/pages/localChannelLineup/components/Page';
import {address} from 'src/pages/localChannelLineup/store/selectors/address';
import {channels} from 'src/shared/channelLineup/selectors';
import {connect} from 'react-redux';
import {filter} from 'src/pages/localChannelLineup/store/selectors/filter';
import {firstName} from 'src/shared/user/selectors';
import {hideFirstName} from 'src/pages/localChannelLineup/store/actions/hideFirstName';
import {isAuthenticated} from 'src/shared/auth/selectors';
import {lineupOrder} from 'src/pages/localChannelLineup/store/selectors/lineupOrder';
import {loadChannels} from 'src/pages/localChannelLineup/store/actions/loadChannels';
import {loadLocationSuggestions, clearLocationSuggestions} from 'src/shared/locationSuggestions/actions';
import {locationSuggestions} from 'src/shared/locationSuggestions/selectors';
import {resourceStatus} from 'src/shared/resourceStatus/selectors';
import {setAddress} from 'src/pages/localChannelLineup/store/actions/setAddress';
import {setFilter} from 'src/pages/localChannelLineup/store/actions/setFilter';
import {setLineupOrder} from 'src/pages/localChannelLineup/store/actions/setLineupOrder';
import {showFirstName} from 'src/pages/localChannelLineup/store/selectors/showFirstName';
import {signIn} from 'src/shared/config/urls';

const mapStateToProps = state => ({
  address: address(state),
  channels: channels(state),
  channelsLoading: get(resourceStatus(state), 'loading.channelLineup', false),
  channelsLoaded: get(resourceStatus(state), 'loaded.channelLineup', false),
  channelsError: get(resourceStatus(state), 'error.channelLineup', false),
  filter: filter(state),
  firstName: firstName(state),
  lineupOrder: lineupOrder(state),
  showFirstName: showFirstName(state),
  signInUrl: signIn(state),
  suggestions: locationSuggestions(state),
  isAuthenticated: isAuthenticated(state),
});

const mapDispatchToProps = dispatch => ({
  setAddress: address => dispatch(setAddress(address)),
  setFilter: filter => dispatch(setFilter(filter)),
  setLineupOrder: order => dispatch(setLineupOrder(order)),
  loadChannels: () => {
    dispatch(loadChannels());
    dispatch(hideFirstName());
  },
  loadLocationSuggestions: query => dispatch(loadLocationSuggestions(query)),
  clearLocationSuggestions: () => dispatch(clearLocationSuggestions()),
  print: window.print,
});

export const App = connect(mapStateToProps, mapDispatchToProps)(Page);
